import {
    type TableActionProps,
    ExcelExportButton,
    type BaseActivatedPanelProps,
} from "app/pages/sales-intelligence/common-components/table-actions-panel";
import ExportQuotaHoverContainer from "app/pages/sales-intelligence/modules/quota/containers/ExportQuotaContainer/ExportQuotaHoverContainer";
import { useExportQuota } from "app/pages/sales-intelligence/modules/quota/hooks/useExportQuota";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

import AppsExcelExportPanelContainer from "./AppsExcelExportPanelContainer";

type Props = TableActionProps & {
    numberOfResults: number;
};

const ExcelExportButtonContainer = ({ isDisabled, numberOfResults, onActivate }: Props) => {
    const translate = useTranslation();

    const { isLoading, isQuotaReached, data } = useExportQuota();

    const renderExportPanel = (props: BaseActivatedPanelProps) => (
        <AppsExcelExportPanelContainer
            {...props}
            numberOfResults={numberOfResults}
        />
    );

    const button = (
        <ExcelExportButton
            isDisabled={isDisabled || isLoading || isQuotaReached}
            onClick={() => onActivate(() => renderExportPanel)}
        >
            {translate("si.common.button.export.excel")}
        </ExcelExportButton>
    );

    if (isQuotaReached) {
        return <ExportQuotaHoverContainer quota={data}>{button}</ExportQuotaHoverContainer>;
    }

    return button;
};

export default ExcelExportButtonContainer;
